import { Controller } from "@hotwired/stimulus"
import { HlsPlayback } from "./hls_playback"

// A Document's video sheet, played where it sits. Unlike the Note's mosaic
// there is no viewer to open: the sheet *is* the reading surface, exactly as a
// picture leaf is, so the player is part of the prose rather than a modal over
// it (docs/pla-video.md §4.7).
//
// It asks for the stream when the reader presses play and not when the page
// loads: a document may hold several videos, and painting the index is no
// reason to mint a token — or fetch a megabyte of library — for a sheet nobody
// has opened yet.
export default class extends Controller {
  static values = { url: String, playbackUrl: String }

  connect() {
    this.playback = new HlsPlayback(this.element)
    this.element.src = new URL(this.urlValue, document.baseURI).href
  }

  disconnect() {
    this.playback.stop()
  }

  // The first press is the one that upgrades: after it, the stream is either
  // playing or has already fallen back, and there is nothing left to ask.
  upgrade() {
    if (this.upgraded) return

    this.upgraded = true
    this.playback.play({ url: this.urlValue, playbackUrl: this.playbackUrlValue })
  }

  recoverOriginal() {
    this.playback.fallBackToOriginal()
  }
}
